export default __webpack_public_path__ + "static/media/tab-first.e6077255.svg";